module.exports = __webpack_public_path__ + "static/img/pay-tpl.99226866.png";